import {Fragment} from "react";
import CircularProgress from "@mui/material/CircularProgress";
import ActionButton from "../../../../../common/ActionButton";
import PerfectResponseModal from "./PerfectResponseModal/PerfectResponseModal";
import useModalSetup from "../../../../../hooks/useModalSetup";
import {PLATFORM} from "../../../../Messages/MessageDetails/Utilities/MessageDetailsUtils";

export default function PerfectResponseAction({
  submitVoteLoading,
  handleSubmitPerfectResponse,
  disableButton,
  loadingHtmlBody,
  handleCloseTicket,
  closeTicket,
    platform
}) {
    const {handleOpenModal, handleCloseModal, openModal} = useModalSetup();

    return(
        <Fragment>
            {platform === PLATFORM.VOTE &&
                <ActionButton
                    label={(submitVoteLoading) ? <CircularProgress size={15} sx={{ color: '#FFFFFF'}}/> : 'Perfect'}
                    action={handleOpenModal}
                    disabled={disableButton || loadingHtmlBody}
                    withIcon={false}
                    sx={style.perfectResponseButton}
                />
            }
            <PerfectResponseModal
                title={'Submit response'}
                open={openModal}
                handleClose={handleCloseModal}
                handleSubmit={handleSubmitPerfectResponse}
                handleCloseTicket={handleCloseTicket}
                closeTicket={closeTicket}
            />
        </Fragment>
    )
}

const style = {
    perfectResponseButton: {
        height: '32px',
        width: '100px',
    },
}